"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEntryData = exports.getEntryData = exports.useConferenceAttendance = exports.getConferenceAttendance = exports.useConferenceReport = exports.getConferenceReport = exports.useEnquiriesList = exports.useConferenceList = exports.connectionConferenceList = exports.deleteConferenceList = exports.updateConferenceList = exports.postConferenceList = exports.quitEnquiriesList = exports.postoutEnquiriesList = exports.postEnquiriesList = void 0;
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
// (회의실) conference 리스트 조회
const getConferenceList = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/conferences?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (회의실) 1:1라이브  리스트 조회
const getEnquiriesList = async (queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/enquiries?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (회의실) 1:1 라이브 대기열 등록
const postEnquiriesList = async (data) => {
    const url = `/api/mimac/v1/enquiries/${data.id}/queue-in`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.postEnquiriesList = postEnquiriesList;
// (회의실) 1:1 라이브 대기열 해제
const postoutEnquiriesList = async (id) => {
    const url = `/api/mimac/v1/enquiries/${id}/queue-out`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.postoutEnquiriesList = postoutEnquiriesList;
// 문의 퇴장
const quitEnquiriesList = async (id) => {
    const url = `/api/mimac/v1/enquiries/${id}/quit`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.quitEnquiriesList = quitEnquiriesList;
// (회의실) 강의실 등록
const postConferenceList = async (data) => {
    const url = `/api/mimac/v1/conferences`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.postConferenceList = postConferenceList;
// (회의실) 강의실 수정
const updateConferenceList = async ({ id, props }) => {
    const url = `/api/mimac/v1/conferences/${id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(props),
    });
};
exports.updateConferenceList = updateConferenceList;
// (회의실) 강의실 삭제
const deleteConferenceList = async (id) => {
    const url = `/api/mimac/v1/conferences/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.deleteConferenceList = deleteConferenceList;
// (회의실) r강의실 회의 연결
const connectionConferenceList = async ({ id, props }) => {
    const url = `/api/mimac/v1/conferences/${id}/connect`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(props),
    });
};
exports.connectionConferenceList = connectionConferenceList;
// (회의실) conference 리스트 조회 -useConferenceList
const useConferenceList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)(`conferences_${queryString}`, () => getConferenceList(queryString));
};
exports.useConferenceList = useConferenceList;
// (회의실) conference 리스트 조회 -useConferenceList
const useEnquiriesList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)(`enquires_${queryString}`, () => getEnquiriesList(queryString));
};
exports.useEnquiriesList = useEnquiriesList;
// (회의 출결 현황 조회)
const getConferenceReport = async (id, queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/members/${id}/conference-report?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getConferenceReport = getConferenceReport;
const useConferenceReport = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`conferenceReport_${data}`, data], () => (0, exports.getConferenceReport)(data.id, queryString));
};
exports.useConferenceReport = useConferenceReport;
// (회의 출결 현황 조회)
const getConferenceAttendance = async (id, queryString) => {
    const url = `/api/mimac/v1/conferences/${id}/attendance?${queryString}`; // API 엔드포인트 생성`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getConferenceAttendance = getConferenceAttendance;
const useConferenceAttendance = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`conferenceAttendance_${data}`, data], () => (0, exports.getConferenceAttendance)(data.id, queryString));
};
exports.useConferenceAttendance = useConferenceAttendance;
// (회의실) entry_log 리스트 조회
const getEntryData = async (data) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/conferences/${data.id}/entry-logs`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getEntryData = getEntryData;
// (회의실) entry_log 리스트 조회
const useEntryData = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`conferenceAttendance_${data}`, data], () => (0, exports.getEntryData)(data));
};
exports.useEntryData = useEntryData;
